import React from 'react';

import Confirm from 'components/confirm/Confirm';

const FieldDeleteConfirm = ({
    isOpen,
    setOpen,
    deleteLabel,
    canDelete,
    onDelete,
}) => (
    <Confirm
        title="Delete Field"
        message={`Are you sure you want to delete "${deleteLabel}"? This cannot be undone.`}
        isOpen={isOpen}
        setOpen={setOpen}
        onConfirm={() => {
            if (typeof onDelete === 'function' && canDelete) {
                onDelete();
            }
            setOpen(false);
        }}
    />
);

export default FieldDeleteConfirm;
